import React from "react";

function siteName() {
  return (process.env.REACT_APP_SITE_NAME || "Vibes Reserve").trim();
}

/**
 * Website shell: main + footer (no top title bar — hero starts at top).
 */
export default function WebsiteLayout({ children }) {
  const year = new Date().getFullYear();
  const name = siteName();

  return (
    <div className="site-root d-flex flex-column min-vh-100">
      <main className="site-main flex-grow-1">{children}</main>

      <footer className="site-footer border-top mt-auto">
        <div className="container py-4 px-3 px-md-4">
          <p className="site-footer__text mb-0 small text-center">
            © {year} {name}. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
